import { Box, TableBody, TableCell, TableRow } from '@mui/material';
import React, { Component } from 'react';
import QRCode from "react-qr-code";
import { isEmpty } from 'lodash';
import { Table } from 'react-bootstrap';
import { 
    updateEquipement,
    fetchEquipements,
    fetchVehicules,
 } from '../../../store/actions/equipementAction'
import { 
    updateLocalisation,
    fetchParentLocalisations,
    fetchChildLocalisations,
 } from '../../../store/actions/localisationAction'
import { 
    newLoan,
    // updateLoan,
    fetchLoans,
 } from '../../../store/actions/loanAction'
class EquipementInfoSingle extends Component {
    state = { 
        infos: "",
    }
    componentDidMount = () => {
        const { id } = this.props.match.params;
        const { EQUIPEMENTS } = this.props;

        if (!isEmpty(id)) {
            let equipement = EQUIPEMENTS[id]
            // let equipement = {}
            // let equipement = this.props.getEquipementInfo(id)
            
            if (!isEmpty(equipement)) {            
                this.setState({ infos: equipement })
            }   else {
                
                this.setState({ error : 'not found' })
            } 
        } else {
            this.setState({ error : 'not found' })

        }
    }

    // setQrCodeInfo = () => {
    //     // name
    //     // date
    //     // id
    // }

    render() {
        const { infos } = this.state;
        return (
            <Box p={1}>
                {this.state.error &&
                    <Box p={3}>
                        Matériel Introuvable
                    </Box>
                }
                {this.state.infos &&
                    // <QRCode
                    //     size={50}
                    //     style={{ height: "auto", maxWidth: "100%", width: "100%" }}
                    //     value={this.state.equipement_ref}
                    //     viewBox={`0 0 50 50`}
                    // />
                    <Box p={3}>
                        <Table>
                            <TableBody>
                                <TableRow>
                                    <TableCell>
                                        Désignation : 
                                    </TableCell>
                                    <TableCell>
                                        {infos.equipement_name}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        Date d'aquisition: 
                                    </TableCell>
                                    <TableCell>
                                        {new Date(infos.equipement_date).toLocaleDateString("fr-FR")}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        ID: 
                                    </TableCell>
                                    <TableCell>
                                        {infos.equipement_id}
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell>
                                        Référence : 
                                    </TableCell>
                                    <TableCell>
                                        {infos.equipement_ref}
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </Box>
                    
                }
            </Box>
        );
    }
}

export default EquipementInfoSingle;
// function mapStateToProps(state){// transform elements from store's state into props in this component
//     return {
//         currentUser: state.auth.user,
//         isAdmin: state.auth.isAdmin,
//         isUserPlus: state.auth.isUserPlus,
//         isSuper: state.auth.isSuperAdmin,
//         ACCESS: state.access,
//         STATE: state.request,
//         LOCALISATIONS: state.localisations,
//         VEHICULES: state.vehicules,
//         EQUIPEMENTS: state.equipements,
//         USAGES: state.usages,
//         LOANS: state.loans,
//     }
// }

// function mapDispatchToProps(dispatch){
//     return bindActionCreators({
//         fetchEquipements,
//         updateEquipement,
//         updateLocalisation,
//         fetchParentLocalisations,
//         fetchChildLocalisations,
//         fetchVehicules,
//         fetchLoans,
//     }, dispatch)
// }

// export default connect(mapStateToProps, mapDispatchToProps)(EquipementInfoSingle); // RequireAdmin
